import React, { useState, useEffect, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { GraduationCap, Search, BookOpen, Sparkles, UserCheck } from 'lucide-react';

// Fallback seed data if the database has not yet been populated
const fallbackScholars = [
  {
    _id: "1",
    name: "Shruti Acharya",
    topic: "Essays on Barriers and Facilitators of Vaccination",
    researchSummary: "Investigating behavioral, systemic, and institutional factors influencing vaccine uptake, distribution frameworks, and public health delivery.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/image-4.png?resize=627%2C628&ssl=1"
  },
  {
    _id: "2",
    name: "Nehal Jain",
    topic: "Equity and Inclusivity within the Healthcare Industry",
    researchSummary: "Nehal Jain’s research examines equity and inclusivity within the healthcare industry. As healthcare undergoes rapid digital transformation, the ways in which digital health organizations conceptualize and operationalize health equity remain largely fragmented. Her work investigates structural, organizational, and operational challenges in product integration.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image.png?resize=730%2C816&ssl=1"
  },
  {
    _id: "3",
    name: "Wungkhai Hommichon",
    topic: "Overcoming Clinician Resistance To AI In Cancer Detection: Strategic Roadmap For Adoption",
    researchSummary: "Her research examines the persistent resistance of oncologists and radiologists to adopting AI in cancer detection. Grounded in the Technology Acceptance Model, Diffusion of Innovations theory, and Trust in Automation frameworks to develop strategic levers for clinical integration.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/image-2-2.png?resize=627%2C940&ssl=1"
  },
  {
    _id: "4",
    name: "Muskan Verma",
    topic: "Strategic Entrepreneurship, Strategic Innovation, and Strategic Renewal & Transformation",
    researchSummary: "Examining how strategic entrepreneurship enables firms to enhance performance in turbulent environments, simultaneously balancing opportunity-seeking and advantage-seeking behaviors.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-3.png?resize=578%2C631&ssl=1"
  },
  {
    _id: "5",
    name: "Siya Choudhary",
    topic: "Antecedents of Generative AI Implementation and Its Impact on Firm Competitiveness",
    researchSummary: "Investigating how organizations routinize Generative AI into everyday work practices and analyze strategic alignment with top management support.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-4-1.png?resize=730%2C913&ssl=1"
  },
  {
    _id: "6",
    name: "Sanjna Shukla",
    topic: "AI Scribe Technology for Clinical Documentation Needs",
    researchSummary: "Doctoral scholar at the University of Queensland–IIT Delhi Research Academy (UQIDAR). Focuses on interdisciplinary initiatives that blend clinical documentation, health policy, and real-world implementation.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-2-3.png?resize=210%2C270&ssl=1"
  },
  {
    _id: "7",
    name: "Dr. Navya Tondak",
    topic: "Autonomous AI, Organizational Governance, and Healthcare Transformation",
    researchSummary: "Her research investigates how organizations maintain accountability and oversight as AI systems learn and act beyond direct human instruction in high-stakes clinical environments.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/06/image-9.png?resize=730%2C1006&ssl=1"
  },
  {
    _id: "8",
    name: "Suman Kumar",
    topic: "Strategic Alliances & Joint Ventures, International Business, Organizational Ambidexterity",
    researchSummary: "Exploring cross-border partnership resilience, governance models, and ambidexterity in emerging markets.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-2.png?resize=730%2C961&ssl=1"
  },
  {
    _id: "9",
    name: "Suvashis Choudhary",
    topic: "Critical Success Factors Influencing The Adoption Of Artificial Intelligence For Cybersecurity",
    researchSummary: "Analyzing organizational security frameworks and strategic levers that drive enterprise AI adoption for cyber threat intelligence.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/image-2-1.png?resize=693%2C693&ssl=1"
  },
  {
    _id: "10",
    name: "Arun Singh",
    topic: "Impact of Strategic Flexibility and Strategic Innovation on Firm Performance",
    researchSummary: "Investigating how flexibility and modular operational designs allow enterprises to pivot amidst supply chain volatility.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/image-6.png?resize=730%2C814&ssl=1"
  },
  {
    _id: "11",
    name: "Ayesha Kutay",
    topic: "Developing Sustainable Financial Models: The Role Of Endowment Funds In HEIs",
    researchSummary: "Frameworks for building institutional financial resilience through modern endowment management in higher education institutes.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/image-5.png?resize=730%2C813&ssl=1"
  },
  {
    _id: "12",
    name: "Priyanka",
    topic: "Exploring The Critical Success Factors for Organizational Innovation Post Strategic Alliances",
    researchSummary: "Evaluating partner integration, capability retention, and collaborative innovation dynamics post alliance formation.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-3-1.png?resize=288%2C350&ssl=1"
  },
  {
    _id: "13",
    name: "Juhi Rajput",
    topic: "Impact of Strategic Factors and Climate Governance on Achieving Net Zero in the Indian Context",
    researchSummary: "Evaluating the interplay of corporate strategy, municipal policies, and national net-zero decarbonization timelines.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-4-2.png?resize=730%2C908&ssl=1"
  },
  {
    _id: "14",
    name: "Pushpendra Rajput",
    topic: "Antecedents Of The Organization Impacting Its Multiple Alliances",
    researchSummary: "Studying network theory, portfolio management, and multi-partner alliance governance in competitive markets.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-5.png?resize=730%2C744&ssl=1"
  },
  {
    _id: "15",
    name: "Radhika Goel",
    topic: "Improving Quality, Equity and Inclusiveness in Healthcare",
    researchSummary: "Evaluating grassroots accessibility, patient-centric delivery channels, and social health determinants in underserved regions.",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-6.png?resize=730%2C730&ssl=1"
  }
];

export default function DoctoralSection() {
  const [scholars, setScholars] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedId, setExpandedId] = useState(null);

  // Fetch live profiles from the backend
  useEffect(() => {
    fetch('https://sanjaydhir.com/api/scholars')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setScholars(data);
        }
      })
      .catch((err) => console.warn('Using fallback scholars list:', err));
  }, []);

  const filtered = useMemo(() => {
    return scholars.filter((s) => {
      const q = searchTerm.toLowerCase();
      return (
        s.name.toLowerCase().includes(q) ||
        (s.topic && s.topic.toLowerCase().includes(q)) ||
        (s.researchSummary && s.researchSummary.toLowerCase().includes(q))
      );
    });
  }, [scholars, searchTerm]);

  return (
    <div className="container py-5 min-vh-100 position-relative text-light" style={{ zIndex: 1 }}>
      
      {/* 1. Header Banner */}
      <div className="row align-items-center g-4 mb-5">
        <div className="col-12 col-lg-8">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3 bg-dark border border-secondary border-opacity-50">
            <GraduationCap size={16} className="text-info" />
            <span className="small text-light fw-medium">Academic Mentorship & Doctoral Supervision</span>
          </div>

          <h1 className="display-5 fw-bold text-white mb-3">
            Doctoral <span style={{ color: '#00f2fe' }}>Scholars</span>
          </h1>

          <p className="lead text-secondary fs-6 mb-4 pe-lg-3">
            Supervising doctoral scholars across AI governance, strategic flexibility, healthcare equity, 
            and climate transition at the Department of Management Studies, IIT Delhi and the UQ-IITD Research Academy.
          </p>

          <div className="d-flex flex-wrap gap-3">
            <div className="p-3 rounded-3 bg-dark border border-secondary border-opacity-25 text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-info">{scholars.length}+</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Ph.D. Researchers</span>
            </div>
            <div className="p-3 rounded-3 bg-dark border border-secondary border-opacity-25 text-center">
              <span className="fs-4 fw-bold text-warning">Interdisciplinary</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>IITD & UQIDAR</span>
            </div>
          </div>
        </div>

        {/* Search Input Bar */}
        <div className="col-12 col-lg-4">
          <div className="position-relative">
            <Search size={18} className="text-secondary position-absolute top-50 start-0 translate-middle-y ms-3" />
            <input
              type="text"
              placeholder="Search scholar by name or topic..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-control rounded-pill ps-5 bg-dark text-light border border-secondary border-opacity-50 py-2 small"
            />
          </div>
        </div>
      </div>

      {/* 2. Responsive Scholar Cards Grid */}
      <div className="row g-4">
        <AnimatePresence>
          {filtered.map((item, idx) => (
            <motion.div
              layout
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3, delay: idx * 0.04 }}
              key={item._id}
              className="col-12 col-md-6 col-lg-4"
            >
              <div 
                className="p-4 rounded-4 h-100 d-flex flex-column justify-content-between position-relative overflow-hidden"
                style={{
                  background: 'rgba(15, 23, 42, 0.85)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  backdropFilter: 'blur(12px)',
                  transition: 'border-color 0.25s ease, transform 0.25s ease'
                }}
              >
                <div>
                  {/* 1:1 Circular Avatar Header */}
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div 
                      className="rounded-circle overflow-hidden flex-shrink-0"
                      style={{
                        width: '78px',
                        height: '78px',
                        border: '2px solid #00f2fe',
                        boxShadow: '0 0 12px rgba(0, 242, 254, 0.35)',
                        backgroundColor: '#0a0f1d'
                      }}
                    >
                      <img 
                        src={item.imageUrl} 
                        alt={item.name} 
                        className="w-100 h-100" 
                        style={{ objectFit: 'cover', display: 'block' }}
                        onError={(e) => {
                          e.target.src = "https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=" + encodeURIComponent(item.name);
                        }}
                      />
                    </div>

                    <div>
                      <h5 className="fw-bold text-white mb-1" style={{ fontSize: '1.15rem' }}>{item.name}</h5>
                      <span className="badge px-2 py-1 rounded-pill small" style={{ background: 'rgba(0, 242, 254, 0.1)', color: '#00f2fe', border: '1px solid rgba(0, 242, 254, 0.25)' }}>
                        Doctoral Researcher
                      </span>
                    </div>
                  </div>

                  {/* Research Topic */}
                  {item.topic && (
                    <div className="mb-3">
                      <span className="small text-secondary fw-semibold text-uppercase d-block" style={{ fontSize: '0.72rem', letterSpacing: '0.05em' }}>
                        Area of Research
                      </span>
                      <p className="text-light fw-medium small mb-0 lh-base">
                        {item.topic}
                      </p>
                    </div>
                  )}

                  {/* Expandable Detailed Summary */}
                  {item.researchSummary && (
                    <div className="pt-2 border-top border-secondary border-opacity-25">
                      <p 
                        className={`text-secondary small mb-0 lh-base ${expandedId === item._id ? '' : 'text-truncate-3'}`}
                        style={{
                          display: expandedId === item._id ? 'block' : '-webkit-box',
                          WebkitLineClamp: expandedId === item._id ? 'unset' : 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden'
                        }}
                      >
                        {item.researchSummary}
                      </p>
                      <button
                        type="button"
                        onClick={() => setExpandedId(expandedId === item._id ? null : item._id)}
                        className="btn btn-link text-info p-0 small mt-1 text-decoration-none fw-semibold"
                        style={{ fontSize: '0.78rem' }}
                      >
                        {expandedId === item._id ? 'Show Less' : 'Read Abstract →'}
                      </button>
                    </div>
                  )}
                </div>

                {/* Footer Indicator */}
                <div className="mt-3 pt-2 d-flex align-items-center gap-1 text-secondary" style={{ fontSize: '0.72rem' }}>
                  <UserCheck size={13} className="text-success" />
                  <span>DMS, IIT Delhi</span>
                </div>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>

        {filtered.length === 0 && (
          <div className="col-12 text-center py-5">
            <p className="text-secondary fs-5 mb-0">No doctoral scholars found matching your search.</p>
          </div>
        )}
      </div>

    </div>
  );
}